import { Component, OnInit } from '@angular/core';
import { SolicitudIntermediarioService } from '../../Service/solicitudIntermediario.service';
import { ParametrosService } from '../../../services/parametros.service';
import { Departamento } from '../../../comun/models/departamento';
import { Ciudad } from '../../../comun/models/ciudad';
import { Router } from '@angular/router';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
import { NeoSolicitudNegada } from '../../Model/neoSolicitudNegada';
import { NeoTiposNegacionService } from '../../../comun/services/neoTiposNegacion.service';
import { NeoTipoNegacion } from '../../../comun/models/neoTipoNegacion';
import { DataLocalStorageService } from '../../Service/dataLocalStorage.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '../../../services/alert.service';
import { UserService } from '../../../services/user.service';
import { DataSessionStorage } from '../../Service/dataSessionStorage.service';
import { CurrencyPipe } from '@angular/common';
import { NeoCalcularCuota } from '../../Model/neoCalcularCuota';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { BancoldexService } from 'src/app/comun/services/bancoldex.service';
import { Constantes } from 'src/app/comun/data/constantes';
import { NeoTrazabilidadAuditoriaDTO } from '../../Model/neoTrazabilidadAuditoriaDTO';
import { TrazabilidadAuditoriaService } from '../../Service/trazabilidad-auditoria.service';

declare var $: any;
//Constantes de parametros
const ParametromensajeNotificacion = 'PAR-103';

const aprobarSolicitud = {
  idSolicitud: '',
  observacion: '',
  idUsuario: null,
  idCliente: null,
  valorDesembolsado: 0,
  tasaFinal: null,
  plazoFinal: null,
  cuotaFinal: null,
  tipoRecurso: null,
  garantia: null
};

const aprobarSolicitudBx = {
  idSolicitud: null,
  idUsuario: null,
  idCliente: null,
  aplicaFNG: null,
  margenFNG: null,
  numeroReferenciaPagareIF: null,
  descripcionGarantia: null,
  plazoFinal: null,
  valorDesembolsado: 0
};

const negarSolicitud = {
  idSolicitud: '',
  observaciones: '',
  idUsuario: null,
  idCliente: null,
  idTipoNegacionDesembolso: null,
};

const PATRON_VALOR_TASA = '^[0-9]{1,3}(.[0-9]{1,3})?$';
const TASA_MINIMA = 0.001;
const TASA_MAXIMA = 1000;

@Component({
    selector: 'app-home-intermediario-financiero',
    templateUrl: './home-intermediario-financiero.component.html',
    styleUrls: ['./home-intermediario-financiero.component.scss'],
    providers: [
        SolicitudIntermediarioService,
        ParametrosService,
        NeoIntermediarioFinancieroService,
        NeoTiposNegacionService,
    ],
    standalone: false
})
export class HomeIntermediarioFinancieroComponent implements OnInit {
  public conteoSolicitudes: Array<number>;
  public departamentos: Departamento[] = [];
  public ciudades: Ciudad[] = [];
  public solicitudesPendientes: any[] = [];
  public tiposNegacion: NeoTipoNegacion[] = [];
  public solicitudNegar: NeoSolicitudNegada;
  public user;
  public neoCalcularCuota: NeoCalcularCuota;
  public CANTIDAD_MAXIMA_PLAZO_MESES = 120;
  habilitarCampos: number = 0.1;
  filterForm: UntypedFormGroup;
  confirmarForm: UntypedFormGroup;
  confirmarBxForm: UntypedFormGroup;
  estados: any[] = [];
  paginaActual: number = 1;
  totalPaginas: number = null;
  habilitarSolicitud: string = '';
  idSolicitudAprobar: string = '';
  observacionSolicitudAprobar: string;
  idSolicitudNegar: string = '';
  idTipoNegacion: number = null;
  textDesembolsoObservacion: string = '';
  tiposNegacionDesembolso: NeoTipoNegacion[] = [];
  cuota: string = '';
  cuotafinal: any;
  periodicidad: null;
  idOpcionNegacion: number;
  textNegacionObservacion: string = '';
  mensajeNotificacion: string = null;
  mensajeEnviadaBE: string = "¡La información de esta solicitud ya ha sido enviada a Banca Electrónica y actualmente se encuentra en trámite!";
  idTrazabilidad: number = 0;

  constructor(
    private readonly _solicitudIntermediarioService: SolicitudIntermediarioService,
    private readonly _parametrosService: ParametrosService,
    private readonly router: Router,
    private readonly _neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
    private readonly _userIntermediarioService: UserService,
    private readonly _neoTiposNegacionService: NeoTiposNegacionService,
    private readonly _dataLocalStorageService: DataLocalStorageService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly alertService: AlertService,
    public pipe: CurrencyPipe,
    private readonly dataSessionStorage: DataSessionStorage,
    private readonly _sweetAlert: SweetAlertService,
    private readonly _bancoldexService: BancoldexService,
    private readonly _serviceTrazabilidad: TrazabilidadAuditoriaService
  ) {
    window.scroll(0, 0);
    //estilos tooltip
    $(function () {
      $('[data-bs-toggle="tooltip"]').tooltip({
        boundary: "window",
        template:
          '<div class="tooltip tooltip-custom" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
      });
    });
    this.getMensajeNotificacion();
    this.user = this._userIntermediarioService.getUser();
    this.conteoSolicitudes = new Array();
    this.solicitudNegar = new NeoSolicitudNegada('', null, null, null);
    this.filterForm = this.formBuilder.group({
      idCiudad: null,
      idDepartamento: null,
      idSolicitud: null,
      fechaRecepcion: null,
      idEstadoSolicitud: null,
      idCliente: this.user.idCliente,
      isFilterDesembolso: false,
      isFilterRevisar: false,
      isFilterAprobar: false,
      idUsuario: this.user.idUsuario,
      pagina: this.paginaActual,
    });

    this.confirmarForm = this.formBuilder.group({
      desembolso: ['', Validators.required],
      valorTasa: ['', Validators.required],
      plazo: ['', Validators.required],
      tipoRecurso: ['', Validators.required],
      garantia: ['', Validators.required],
      observacion: ['', Validators.required],
    });

    this.confirmarBxForm = this.formBuilder.group({
      aplicaFNG: [null, Validators.required],
      margenFNG: [null],
      numeroReferenciaPagareIF: [null, Validators.required],
      descripcionGarantia: [null]
    });
  }

  ngOnInit(): void {
    this.getActualizarLineas();
    this.neoCalcularCuota = new NeoCalcularCuota(
      null,
      null,
      null,
      null
    );
    this.setPipeForm();
    if (this.dataSessionStorage.getFilterHome()) {
      this.filterForm.setValue(this.dataSessionStorage.getFilterHome());
      this.dataSessionStorage.deleteFilterHome();
    }
    this.getSolicitudes();
    this._solicitudIntermediarioService
      .getConteoSolicitudesIntermediario(this.user.idCliente)
      .subscribe(
        (response) => {
          this.conteoSolicitudes = response;
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar los datos');
        }
      );

    this._solicitudIntermediarioService.getEstadosIntermediario(this.user.idUsuario).subscribe(
      (response) => {
        this.estados = response.estados;
      },
      (error) => {
        this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar los datos');
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );

    this._parametrosService.getDepartamentos('169').subscribe(
      (response) => {
        this.departamentos = response['data'];
      },
      (error) => {
        this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar los departamentos');
      }
    );
  }

  getActualizarLineas() {
    this._neoIntermediarioFinancieroService.getValidarLineas(this.user.idCliente).subscribe((resp: any) => {
      if (!resp.exitoso) {
        this._sweetAlert.infoModal(resp.message, false).then((result) => {
          if (result.isConfirmed) {
            this.router.navigate(['/intermediario/administracion/lineascredito']);
          }
        });
      }
    });
  }

  getSolicitudes() {
    this.filterForm.get('pagina').setValue(this.paginaActual);
    this._neoIntermediarioFinancieroService
      .getFiltrarSolicitud(this.filterForm.value)
      .subscribe((data) => {
        this.solicitudesPendientes = data.data;
        this.totalPaginas = data.paginasTotales;
        if (!this.solicitudesPendientes) {
          this.solicitudesPendientes = [];
        }
        return new Promise((resolve, reject) => {
          this.habilitarBotonesSolicitud();
        });

      });
  }

  changePage(i) {
    this.paginaActual = i;
    this.getSolicitudes();
  }

  habilitarBotonesSolicitud() {
    if (this._dataLocalStorageService.getIdSolicitudPendHome() != null) {
      this.habilitarSolicitud =
        this._dataLocalStorageService.getIdSolicitudPendHome();
    }
    if (this.habilitarSolicitud != null) {
      this.solicitudesPendientes.forEach((element, index) => {
        if (element.numeroSolicitud == this.habilitarSolicitud.toString()) {
          this.habilitarCampos = index;
          this._dataLocalStorageService.deleteIdSolicitudPendHome();
        }
      });
    }
  }

  getCiudades(idDepartamento) {
    if (idDepartamento != 'null') {
      this._parametrosService.getCiudades(idDepartamento).subscribe(
        (response) => {
          this.ciudades = response['data'];
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar las ciudades');
        }
      );
    } else {
      this.ciudades = [];
    }
  }

  verDetalleOfertaRevisor(i) {
    this.dataSessionStorage.saveFilterHome(this.filterForm.value);
    const numeroSolicitud = this.solicitudesPendientes[i].numeroSolicitud;
    this._dataLocalStorageService.saveIdSolicitudPendHome(numeroSolicitud);
    this.router.navigate([
      '/intermediario/consultar/detallePropuestaIF/verDetallePropuesta/' +
      numeroSolicitud,
    ]);
  }

  verDetalleSolicitud(i) {
    this.dataSessionStorage.saveFilterHome(this.filterForm.value);
    const numeroSolicitud = this.solicitudesPendientes[i].numeroSolicitud;
    this._dataLocalStorageService.saveIdSolicitudPendHome(numeroSolicitud);
    this.router.navigate([
      '/solicitud/intermediario/' + numeroSolicitud,
    ]);
  }

  negarSolicitud(i) {
    const numeroSolicitud = this.solicitudesPendientes[i].numeroSolicitud;
    if (
      this.solicitudesPendientes[i].idEstadoSolicitud_NeoEstadoSolicitud == Constantes.ESTADOS_SOLICITUD.ENVIADA ||
      this.solicitudesPendientes[i].idEstadoSolicitud_NeoEstadoSolicitud == Constantes.ESTADOS_SOLICITUD.EN_BORRADOR_MICROEMPRESARIO
    ) {

      this.revisionNegacion(this.solicitudesPendientes[i].estadoSolicitud, numeroSolicitud);
      this.correccionNegacionOferta(this.solicitudesPendientes[i].estadoSolicitud, numeroSolicitud);

      this.solicitudNegar.idSolicitud = numeroSolicitud;
      this.solicitudNegar.idCliente = Number(this.user.idCliente);
      this.solicitudNegar.idUsuario = Number(this.user.idUsuario);
      $('#negarModal').modal('show');
      this._neoTiposNegacionService.getTiposNegacionHabilitados().subscribe(
        (response) => {
          this.tiposNegacion = response;
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true,
            'No fue posible cargar los motivos de negación'
          );
        },
        () => {
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
            this.idOpcionNegacion = null;
            this.textNegacionObservacion = '';
          });
        }
      );
    } else if (
      this.solicitudesPendientes[i].idEstadoSolicitud_NeoEstadoSolicitud == Constantes.ESTADOS_SOLICITUD.RECHAZADA_SARLAFT
    ) {
      this.dataSessionStorage.saveFilterHome(this.filterForm.value);
      this.router.navigate([
        '/intermediario/transaccional/aprobarSolicitudes/negarOferta/' +
        numeroSolicitud,
      ]);
    }
  }

  cancelar() {
    this.cerrarTrazabilidad(this.idTrazabilidad);
  }

  aprobar(i) {
    this.dataSessionStorage.saveFilterHome(this.filterForm.value);
    let numeroSolicitud = this.solicitudesPendientes[i].numeroSolicitud;
    let estadoSolicitud =
      this.solicitudesPendientes[i].idEstadoSolicitud_NeoEstadoSolicitud;
    if (
      estadoSolicitud == Constantes.ESTADOS_SOLICITUD.ENVIADA ||
      estadoSolicitud == Constantes.ESTADOS_SOLICITUD.EN_BORRADOR_MICROEMPRESARIO
    ) {
      // Consumir servicio de auditoria...
      this.router.navigate([
        '/intermediario/transaccional/revisarSolicitudes/propuestaIntermediario/' +
        numeroSolicitud,
      ]);
    } else if (
      estadoSolicitud == Constantes.ESTADOS_SOLICITUD.RECHAZADA_SARLAFT ||
      estadoSolicitud == Constantes.ESTADOS_SOLICITUD.VALIDACION_SARLAFT
    ) {
      if (estadoSolicitud == Constantes.ESTADOS_SOLICITUD.RECHAZADA_SARLAFT) {
        this.router.navigate([
          '/intermediario/transaccional/aprobarSolicitudes/aprobarOferta/' +
          numeroSolicitud,
        ]);
      } else if (estadoSolicitud == Constantes.ESTADOS_SOLICITUD.VALIDACION_SARLAFT) {
        this.router.navigate([
          '/intermediario/transaccional/aprobarSolicitudes/confirmarNegacion/' +
          numeroSolicitud,
        ]);
      }
    }
  }

  confirmarNegacionSolicitud() {
    if (
      this.solicitudNegar.id_tipo_negacion != null &&
      this.solicitudNegar.idCliente &&
      this.solicitudNegar.idSolicitud
    ) {
      this.solicitudNegar.id_tipo_negacion = Number(
        this.solicitudNegar.id_tipo_negacion
      );
      if (this.idOpcionNegacion == 6 || this.idOpcionNegacion == 1) {
        if (this.textNegacionObservacion.length > 0) {
          this.solicitudNegar.observaciones = this.textNegacionObservacion;
          this.callServiceNegarSolicitud();
        } else {
          this._sweetAlert.infoModal('¡La observación no puede ser nula!', true);
        }
      } else {
        this.solicitudNegar.observaciones = this.textNegacionObservacion;
        this.callServiceNegarSolicitud();
      }
    } else {
      this._sweetAlert.errorModal("Error!", true,
        'No fue posible cargar los datos para la negación'
      );
    }
  }


  callServiceNegarSolicitud() {
    this._neoIntermediarioFinancieroService
      .negarSolicitud(this.solicitudNegar)
      .subscribe(
        (response) => {
          if (response['exitoso']) {
            this._sweetAlert.successModal('Solicitud negada correctamente');
            this.solicitudNegar = new NeoSolicitudNegada('', null, 0, null, '');
            $('#negarModal').modal('hide');
            this.cerrarTrazabilidad(this.idTrazabilidad);
            this.getSolicitudes();
          } else {
            this._sweetAlert.errorModal("Error!", true, 'No fue posible negar la solicitud');
          }
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true,
            'No fue posible negar la solicitud' +
            this.solicitudNegar.idSolicitud
          );
        }
      );
  }

  devolver(i) {
    this.dataSessionStorage.saveFilterHome(this.filterForm.value);
    const numeroSolicitud = this.solicitudesPendientes[i].numeroSolicitud;
    const estadoSolicitud =
      this.solicitudesPendientes[i].idEstadoSolicitud_NeoEstadoSolicitud;
    if (estadoSolicitud == 4) {
      this.router.navigate([
        '/intermediario/transaccional/aprobarSolicitudes/devolverOferta/' +
        numeroSolicitud,
      ]);
    } else if (estadoSolicitud == 3) {
      this.router.navigate([
        '/intermediario/transaccional/aprobarSolicitudes/devolverNegacion/' +
        numeroSolicitud,
      ]);
    }
  }

  aprobarDesembolso(i) {
    this.aprobacionDesembolso(String(this.solicitudesPendientes[i].numeroSolicitud));
    this.confirmarForm.reset();
    this.confirmarForm.get('observacion').setValue('');
    aprobarSolicitud.idUsuario = Number(this.user.idUsuario);
    aprobarSolicitud.idCliente = Number(this.user.idCliente);
    this.idSolicitudAprobar = this.solicitudesPendientes[i].numeroSolicitud;
    this.confirmarForm.get('desembolso').setValue(this.solicitudesPendientes[i].monto);
    this.confirmarForm.get('valorTasa').setValue(this.solicitudesPendientes[i].tasa);
    this.confirmarForm.get('plazo').setValue(this.solicitudesPendientes[i].plazo);
    this.cuota = this.solicitudesPendientes[i].cuota;
    this.periodicidad = this.solicitudesPendientes[i].periodicidad;
    aprobarSolicitud.idSolicitud = String(this.idSolicitudAprobar);
    $('#aceptarModal').modal('show');
  }

  confirmarAprobacionDesembolso() {
    if (this.confirmarForm.valid) {
      $('#confirmarDesembolso').modal('show');
    } else {
      this.confirmarForm.markAllAsTouched();
    }
  }

  async confirmarDesembolso() {
    $('#aceptarModal').modal('hide');
    aprobarSolicitud.valorDesembolsado = Number(this.confirmarForm.get('desembolso').value.replaceAll(',', ''));
    aprobarSolicitud.plazoFinal = Number(this.confirmarForm.get('plazo').value);
    aprobarSolicitud.tasaFinal = Number(this.confirmarForm.get('valorTasa').value);
    await this.calcularCuota();
    aprobarSolicitud.cuotaFinal = Number(this.cuotafinal).toFixed(2);
    aprobarSolicitud.tipoRecurso = this.confirmarForm.get('tipoRecurso').value;
    aprobarSolicitud.garantia = this.confirmarForm.get('garantia').value;
    aprobarSolicitud.observacion = this.confirmarForm.get('observacion').value;
    this._neoIntermediarioFinancieroService
      .confirmarDesembolso(aprobarSolicitud)
      .subscribe(
        (response) => {
          if (response['exitoso'] == true) {
            this.getSolicitudes();
            this._sweetAlert.successModal(response['mensaje']);
            this.confirmarForm.reset();
            aprobarSolicitud.idCliente = null;
            aprobarSolicitud.idSolicitud = '';
            aprobarSolicitud.idUsuario = null;
            aprobarSolicitud.observacion = '';
            aprobarSolicitud.garantia = null;
            aprobarSolicitud.tipoRecurso = '';
            $('#aceptarModal').modal('hide');
            this.cerrarTrazabilidad(this.idTrazabilidad);
          } else {
            this._sweetAlert.errorModal("Error!", true, 'No fue posible confirmar el desembolso');
          }
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'No fue posible confirmar el desembolso');
        }
      );
  }

  aprobarDesembolsoBx(i) {
    this.aprobacionDesembolso(String(this.solicitudesPendientes[i].numeroSolicitud));
    this.confirmarBxForm.reset();
    aprobarSolicitudBx.idUsuario = Number(this.user.idUsuario);
    aprobarSolicitudBx.idCliente = Number(this.user.idCliente);
    this.idSolicitudAprobar = this.solicitudesPendientes[i].numeroSolicitud;
    aprobarSolicitudBx.idSolicitud = String(this.solicitudesPendientes[i].numeroSolicitud);
    aprobarSolicitudBx.valorDesembolsado = Number(this.solicitudesPendientes[i].monto);
    aprobarSolicitudBx.plazoFinal = Number(this.solicitudesPendientes[i].plazo);
    $('#confirmarDesembolsoBX').modal('show');
  }

  validarGarantia(x: boolean) {
    if (x === true) {
      this.setearValidadoresForm('margenFNG', [
        Validators.required,
      ]);
      this.setearValidadoresForm('descripcionGarantia', [
        Validators.required, Validators.pattern('^[A-Za-zÁÉÍÓÚáéíóúÑñ0-9 ]{20,300}$')
      ]);
    } else {
      this.setearValidadoresForm('margenFNG', null);
      this.setearValidadoresForm('descripcionGarantia', null);
      this.confirmarBxForm.get('descripcionGarantia').setValue(null);
      this.confirmarBxForm.get('margenFNG').setValue(null);
    }
  }

  confirmarDesembolsoRecursosBancoldex() {
    $('#confirmarDesembolsoBX').modal('hide');
    aprobarSolicitudBx.aplicaFNG = this.confirmarBxForm.get('aplicaFNG').value;
    aprobarSolicitudBx.margenFNG = this.confirmarBxForm.get('margenFNG').value;
    aprobarSolicitudBx.descripcionGarantia = this.confirmarBxForm.get('descripcionGarantia').value;
    aprobarSolicitudBx.numeroReferenciaPagareIF = this.confirmarBxForm.get('numeroReferenciaPagareIF').value;
    this._neoIntermediarioFinancieroService
      .confirmarDesembolsoBx(aprobarSolicitudBx)
      .subscribe(
        (response) => {
          if (response['exitoso'] == true) {
            this.getSolicitudes();
            this._sweetAlert.successModal(response['mensaje']);
            this.confirmarBxForm.reset();
            aprobarSolicitudBx.idSolicitud = null;
            aprobarSolicitudBx.idUsuario = null;
            aprobarSolicitudBx.idCliente = null;
            aprobarSolicitudBx.aplicaFNG = null;
            aprobarSolicitudBx.margenFNG = null;
            aprobarSolicitudBx.numeroReferenciaPagareIF = null;
            aprobarSolicitudBx.descripcionGarantia = null;
            aprobarSolicitudBx.valorDesembolsado = 0;
            $('#aceptarModal').modal('hide');
            this.cerrarTrazabilidad(this.idTrazabilidad);
          } else {
            this._sweetAlert.errorModal("Error!", true, response['mensaje']);
          }
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'Error al crear solicitud en Banca Electrónica.');
        }
      );
  }

  async calcularCuota() {
    if (
      aprobarSolicitud.valorDesembolsado != null &&
      aprobarSolicitud.valorDesembolsado !== 0 &&
      aprobarSolicitud.plazoFinal !== 0 &&
      aprobarSolicitud.tasaFinal !== 0 &&
      this.periodicidad !== 0
    ) {
      this.neoCalcularCuota.monto = aprobarSolicitud.valorDesembolsado;
      this.neoCalcularCuota.plazo = Number(aprobarSolicitud.plazoFinal);
      this.neoCalcularCuota.tasafinalEA = Number(aprobarSolicitud.tasaFinal);
      this.neoCalcularCuota.periodicidad = Number(this.periodicidad);
      let answer = await this._neoIntermediarioFinancieroService
        .coutaRecursosPropios(this.neoCalcularCuota).toPromise();
      if (answer['exitoso'] == true) {
        this.cuotafinal = answer['cuotaAproximada'];
      } else {
        this._sweetAlert.errorModal("Error!", true,
          'error'
        );
      }
    }
  }

  validarTasa() {
    if (this.confirmarForm.get('valorTasa').value != null) {
      this.setearValidadoresLineaInterediarioForm('valorTasa', [
        Validators.required,
        Validators.min(TASA_MINIMA),
        Validators.max(TASA_MAXIMA),
        Validators.pattern(PATRON_VALOR_TASA),
      ]);
    } else {
      this.setearValidadoresLineaInterediarioForm('valorTasa', null);
    }
  }

  setearValidadoresLineaInterediarioForm(
    nombreCampo: string,
    validadores: any
  ) {
    this.confirmarForm.controls[nombreCampo].setValidators(
      validadores
    );
    this.confirmarForm.controls[
      nombreCampo
    ].updateValueAndValidity();
  }

  negarDesembolso(i) {
    this.negacionDesembolso(String(this.solicitudesPendientes[i].numeroSolicitud));
    this.idSolicitudNegar = this.solicitudesPendientes[i].numeroSolicitud;
    negarSolicitud.idSolicitud = String(this.idSolicitudNegar);
    negarSolicitud.idCliente = Number(this.user.idCliente);
    negarSolicitud.idUsuario = Number(this.user.idUsuario);
    $('#negarDesembolsoModal').modal('show');
    this._parametrosService.getTiposNegacionDesembolso().subscribe(
      (response: any) => {
        this.tiposNegacionDesembolso = response;
      },
      (error) => {
        this._sweetAlert.errorModal("Error!", true,
          'No fue posible cargar los motivos de negación'
        );
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
          this.idTipoNegacion = null;
          this.textDesembolsoObservacion = '';
        });
      }
    );
  }

  confirmarNegacionDesembolso() {
    if (this.idTipoNegacion != null && this.textDesembolsoObservacion.length != 0) {
      if (negarSolicitud.idCliente && negarSolicitud.idSolicitud) {
        negarSolicitud.observaciones = this.textDesembolsoObservacion;
        negarSolicitud.idTipoNegacionDesembolso = Number(this.idTipoNegacion);
        this._neoIntermediarioFinancieroService
          .negarDesembolso(negarSolicitud)
          .subscribe(
            (response) => {
              if (response['exitoso'] == true) {
                this.getSolicitudes();
                this._sweetAlert.successModal('Negación de desembolso realizada correctamente.');
                negarSolicitud.idCliente = null;
                negarSolicitud.observaciones = '';
                negarSolicitud.idSolicitud = '';
                negarSolicitud.idUsuario = null;
                negarSolicitud.idTipoNegacionDesembolso = '';
                this.cerrarTrazabilidad(this.idTrazabilidad);
                $('#negarDesembolsoModal').modal('hide');
              } else {
                this._sweetAlert.errorModal("Error!", true, 'No fue posible negar el desembolso.');
              }
            },
            (error) => {
              this._sweetAlert.errorModal("Error!", true,
                'No fue posible negar el desembolso.' + this.idSolicitudNegar
              );
            }
          );
      } else {
        this._sweetAlert.errorModal("Error!", true,
          'No fue posible cargar los datos para la negación'
        );
      }
    } else {
      if (this.idTipoNegacion == null) {
        this._sweetAlert.errorModal("Error!", true, 'Seleccione el motivo de negación');
      } else {
        this._sweetAlert.errorModal("Error!", true, 'Describa la observacion de la negación!');
      }
    }
  }

  limpiarFiltro() {
    this.filterForm.get('idCiudad').setValue(null);
    this.filterForm.get('idDepartamento').setValue(null);
    this.filterForm.get('idSolicitud').setValue(null);
    this.filterForm.get('fechaRecepcion').setValue(null);
    this.filterForm.get('idEstadoSolicitud').setValue(null);
    this.filterForm.get('pagina').setValue(1);
    this.paginaActual = 1;
    this.getSolicitudes();
  }

  setPipeForm() {
    this.confirmarForm.controls['desembolso'].valueChanges.subscribe(
      (data) => {
        if (data !== null) {
          this.confirmarForm.patchValue(
            {
              desembolso: this.pipe.transform(
                data.toString().replace(/\D/g, '').replace(/^0+/, ''),
                '',
                '',
                '1.0-0'
              ),
            },
            { emitEvent: false }
          );
        }
      }
    );
  }

  validateField(key: string) {
    return (
      (this.confirmarForm.get(key).dirty ||
        this.confirmarForm.get(key)?.touched) &&
      this.confirmarForm.get(key)?.invalid
    );
  }

  validateFieldBx(key: string) {
    return (
      (this.confirmarBxForm.get(key).dirty ||
        this.confirmarBxForm.get(key)?.touched) &&
      this.confirmarBxForm.get(key)?.invalid
    );
  }

  validateNumber(event: any) {
    const pattern = /[0-9.]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  setearValidadoresForm(
    nombreCampo: string,
    validadores: any
  ) {
    this.confirmarBxForm.controls[nombreCampo].setValidators(
      validadores
    );
    this.confirmarBxForm.controls[
      nombreCampo
    ].updateValueAndValidity();
  }

  getMensajeNotificacion() {
    var json = {
      idParametro: ParametromensajeNotificacion,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        const respuesta = response['data'];
        this.mensajeNotificacion = String(respuesta[0].valorParametro);
      },
      (error) => {
      }
    );
  }

  // Trazabilidad
  revisionNegacion(estado: string, idSolicitud: string) {
    if (estado == Constantes.PENDIENTE) {
      const body: NeoTrazabilidadAuditoriaDTO = {
        nombreSeccion: 'HOME',
        nombrePantalla: Constantes.NEGAR_SOLICITUD,
        idCliente: +this.user.idCliente,
        idUsuario: +this.user.idUsuario,
        idSolicitud: String(idSolicitud),
        perfil: Constantes.PERFIL_ALIADO
      }
      this._serviceTrazabilidad.generarRevisionNegacion(body).subscribe(
        {
          next: resp => {
            this.idTrazabilidad = resp.trazabilidad.idTrazabilidad;
          },
          error: err => {
          }
        });
    }

  }

  correccionNegacionOferta(estado: string, idSolicitud: string) {
    if (estado == Constantes.DEVUELTA_APROBADOR) {
      const body: NeoTrazabilidadAuditoriaDTO = {
        nombreSeccion: Constantes.HOME,
        nombrePantalla: Constantes.NEGAR_OFERTA,
        idCliente: +this.user.idCliente,
        idUsuario: +this.user.idUsuario,
        idSolicitud: String(idSolicitud),
        perfil: Constantes.PERFIL_ALIADO
      }
      this._serviceTrazabilidad.generarCorreccionNegacionOferta(body).subscribe(
        {
          next: resp => {
            this.idTrazabilidad = resp.trazabilidad.idTrazabilidad;
          },
          error: err => {
          }
        });
    }

  }

  aprobacionDesembolso(idSolicitud: string) {
    const body: NeoTrazabilidadAuditoriaDTO = {
      nombreSeccion: 'HOME',
      nombrePantalla: Constantes.CONFIRMAR_DESEMBOLSO,
      idCliente: +this.user.idCliente,
      idUsuario: +this.user.idUsuario,
      idSolicitud: String(idSolicitud),
      perfil: Constantes.PERFIL_ALIADO
    }
    this._serviceTrazabilidad.generarAprobacionDesembolso(body).subscribe(
      {
        next: resp => {
          this.idTrazabilidad = resp.trazabilidad.idTrazabilidad;
        },
        error: err => {
        }
      });
  }

  negacionDesembolso(idSolicitud: string) {
    const body: NeoTrazabilidadAuditoriaDTO = {
      nombreSeccion: 'HOME',
      nombrePantalla: Constantes.NEGAR_DESEMBOLSO,
      idCliente: +this.user.idCliente,
      idUsuario: +this.user.idUsuario,
      idSolicitud: String(idSolicitud),
      perfil: Constantes.PERFIL_ALIADO
    }
    this._serviceTrazabilidad.generarNegacionDesembolso(body).subscribe(
      {
        next: resp => {
          this.idTrazabilidad = resp.trazabilidad.idTrazabilidad;
        },
        error: err => {
        }
      });
  }


  cerrarTrazabilidad(idTrazabilidad: number) {
    this._serviceTrazabilidad.cierreTrazabilidad(idTrazabilidad).subscribe({
      next: resp => {
      },
      error: err => {
      }
    });
  }
}
